<div class="workshop-container-wrapper__row__detail_schedule_visitors__group">
  @if (attendees.length > 0) {
    <img class="workshop-container-wrapper__row__detail_schedule_visitors__group__icon"
      src="assets/images/workshop_group.svg"/>
  }
  <div class="workshop-container-wrapper__row__detail_schedule_visitors__group__chips">
    <mat-chip-listbox>
      @for (name of attendees.slice(0, 3); track name) {
        <mat-chip-option [disabled]="!isRemoval"
          (removed)="removeAttendees(name)"
          [removable]="isRemoval">{{name}}
          @if (isRemoval) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip-option>
      }
      @if (attendees.length > 3) {
        <mat-chip-option  [disabled]="!isRemoval">+{{attendees.length - 3}}</mat-chip-option>
      }
    </mat-chip-listbox>
  </div>
</div>
